<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="cont"></a><a id="page_6"></a><a id="page_7">CONTENTS</a></h2><a id="page_7">
</a><p class="cont"><a id="page_7"></a><a class="nounder" href="#/xhtml/intro#intro">Introduction</a></p>
<p class="cont"><a class="nounder" href="#/xhtml/ch01#ch01"><strong>CHAPTER 1</strong><br/>The Gluten-Free Vegan Pantry &amp; Basics</a></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>CHAPTER 2</strong><br/>Breakfasts</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>CHAPTER 3</strong><br/>Main Courses</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>CHAPTER 4</strong><br/>Salads &amp; Soups</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>CHAPTER 5</strong><br/>Appetizers, Sides &amp; Snacks</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>CHAPTER 6</strong><br/>Desserts &amp; Beverages</span></p>
<p class="indent"> </p>
<p class="conta"><span class="nounder" href="#/xhtml/resource#resource" title="Link target outside of Sample">Vegan Resources</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/about#about" title="Link target outside of Sample">About the Author</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="image"><img alt="image" src="images/common-3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?99390574